import Swiper, {
  Autoplay,
  Navigation,
  Controller,
  EffectFade,
  EffectCreative,
} from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let heroProductSwiperWr = document.querySelectorAll('.hero-product-swiper-wr');
heroProductSwiperWr.forEach((el) => {
  if (el) {
    let swiperThumbsEl = el.querySelector('.swiper-thumbs');
    let swiperMainEl = el.querySelector('.swiper-main');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = swiperThumbsEl.querySelectorAll('.swiper-slide').length;
    let initialSlide = slidesCount > 1 ? 1 : 0;
    const btn360 = document.querySelector('.hero-product-360-btn');
    const slide360 = document.querySelector('.product-thumb-item-360');

    let thumbSwiper = new Swiper(swiperThumbsEl, {
      modules: [Autoplay, Navigation, Controller, EffectCreative],
      initialSlide: initialSlide,
      speed: 800,
      threshold: 10,
      slidesPerView: 1,
      slideToClickedSlide: true,
      centeredSlides: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      effect: 'creative',
      creativeEffect: {
        prev: {
          translate: [0, '-100%', 0],
          scale: 0.75,
        },
        next: {
          translate: [0, '100%', 0],
          scale: 0.75,
        },
      },
      breakpoints: {
        751: {
          direction: 'vertical',
          slidesPerView: 1,
          creativeEffect: {
            prev: {
              translate: [0, '-100%', 0],
              scale: 0.75,
            },
            next: {
              translate: [0, '100%', 0],
              scale: 0.75,
            },
          },
        },
        1100: {
          creativeEffect: {
            prev: {
              translate: [0, 'calc(-100% + 12px)', 0],
              scale: 0.75,
            },
            next: {
              translate: [0, 'calc(100% - 12px)', 0],
              scale: 0.75,
            },
          },
        },
      },

      /*  autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
        },*/

      on: {
        slideChange: function () {
          let activeSlide = swiperThumbsEl.querySelectorAll('.swiper-slide')[this.activeIndex];
          if (activeSlide) {
            let productSlug = activeSlide.dataset.productSlug;
            let productsMethods = activeSlide.dataset.priceId;
            let productId = activeSlide.dataset.productId;

            load(
              'change-price',
              `product_slug=${productSlug}`,
              `products_methods=${productsMethods}`,
              `product_id=${productId}`
            );
          }
        },
      },
    });

    let mainSwiper = new Swiper(swiperMainEl, {
      modules: [EffectFade, Controller],
      spaceBetween: 20,
      slidesPerView: 1,
      speed: 800,
      threshold: 10,
      effect: 'fade',
      initialSlide: initialSlide,
      autoHeight: true,
      fadeEffect: {
        crossFade: true,
      },
      allowTouchMove: false,
      breakpoints: {
        751: {
          autoHeight: false,
        },
      },
    });

    swiperObserver(thumbSwiper);

    thumbSwiper.controller.control = mainSwiper;
    mainSwiper.controller.control = thumbSwiper;

    if (btn360 && slide360) {
      btn360.addEventListener('click', function () {
        const slide360Parent = slide360.parentElement;
        if (slide360Parent) {
          const targetIndex = Array.from(
            swiperMainEl.querySelectorAll('.swiper-slide')
          ).indexOf(slide360Parent);
          if (targetIndex !== -1) {
            mainSwiper.slideTo(targetIndex);
          }
        }
      });
    }

    const priceSelect = document.querySelector('#price-select');

    if (priceSelect && mainSwiper) {
      const findSlideIndexByDataAttr = (dataValue) => {
        if (!dataValue) return -1;

        const slides = mainSwiper.slides;
        for (let i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-slide') === dataValue) {
            return i;
          }
        }
        return -1;
      };

      let isProgrammaticSlideChange = false;

      // Event delegation for dynamic content
      document.addEventListener('change', function (e) {
        if (e.target && e.target.id === 'price-select') {
          const select = e.target;
          const selectedOption = select.options[select.selectedIndex];
          const slideAttr = selectedOption.getAttribute('data-slide');

          if (slideAttr) {
            const targetIndex = findSlideIndexByDataAttr(slideAttr);
            if (targetIndex !== -1) {
              isProgrammaticSlideChange = true;
              mainSwiper.slideTo(targetIndex);
            }
          }

          // Fix for Choices.js: remove 'is-selected' from siblings
          if (window.getChoice) {
            const choice = window.getChoice(select);
            if (choice) {
              const containerOuter = choice.containerOuter.element || choice.containerOuter;
              if (containerOuter && containerOuter.querySelector) {
                const dropdownList = containerOuter.querySelector('.choices__list--dropdown');
                if (dropdownList) {
                  const selectedItems = dropdownList.querySelectorAll('.is-selected, .choices__item--selected');
                  selectedItems.forEach((item) => {
                    const itemValue = item.getAttribute('data-value');
                    if (itemValue && itemValue.toString() !== select.value.toString()) {
                      item.classList.remove('is-selected', 'choices__item--selected');
                      item.setAttribute('aria-selected', 'false');
                    }
                  });
                }
              }
            }
          }
        }
      });

      // Override slideChange on thumbSwiper to prevent loop
      thumbSwiper.on('slideChange', function () {
        if (isProgrammaticSlideChange) {
          // Reset the flag and do not fire the AJAX request if this was triggered by the select
          isProgrammaticSlideChange = false;
          return;
        }

        let activeSlide = swiperThumbsEl.querySelectorAll('.swiper-slide')[this.activeIndex];
        if (activeSlide) {
          let productSlug = activeSlide.dataset.productSlug;
          let productsMethods = activeSlide.dataset.priceId;
          let productId = activeSlide.dataset.productId;

          // Only load if not triggered by the select itself
          load(
            'change-price',
            `product_slug=${productSlug}`,
            `products_methods=${productsMethods}`,
            `product_id=${productId}`
          );
        }
      });

      // Initial check
      const initialOption = priceSelect.options[priceSelect.selectedIndex];
      const initialSlideAttr = initialOption?.getAttribute('data-slide');
      if (initialSlideAttr) {
        const initialIndex = findSlideIndexByDataAttr(initialSlideAttr);
        if (initialIndex !== -1) {
          isProgrammaticSlideChange = true;
          mainSwiper.slideTo(initialIndex, 0);
        }
      }
    }
  }
});
